import { JSX } from 'react'

import { IconProps } from '../../icon'

const Philosophy: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M31.5621 21.7474C31.5621 24.9275 28.9783 27.5113 25.7982 27.5113C22.618 27.5113 20.0342 24.9275 20.0342 21.7474C20.0342 18.5672 22.618 15.9834 25.7982 15.9834C28.9783 15.9834 31.5621 18.5672 31.5621 21.7474Z'
      fill='#F9D865'
    />
    <path
      d='M35.0404 40H33.7153V29.0021C33.7153 28.8364 33.7816 28.6708 33.9141 28.5383C36.0342 26.4182 37.1936 23.6025 37.1936 20.588C37.1936 14.3602 32.1253 9.32505 25.9306 9.32505C19.7029 9.32505 14.6677 14.3934 14.6677 20.588C14.6677 20.7536 14.6677 20.9193 14.6677 21.0849C14.6677 21.2174 14.6346 21.3499 14.5683 21.4493L11.3219 27.147H12.9451C13.3095 27.147 13.6077 27.4451 13.6077 27.8095V32.5135C13.6077 33.9379 14.7671 35.0642 16.1584 35.0642H21.2598C21.6242 35.0642 21.9224 35.3623 21.9224 35.7267V40H20.5973V36.3892H16.1584C14.0052 36.3892 12.2826 34.6335 12.2826 32.5135V28.472H10.1625C9.93064 28.472 9.69876 28.3395 9.59938 28.1408C9.46687 27.942 9.46687 27.677 9.59938 27.4783L13.3758 20.9524C13.3758 20.8199 13.3758 20.6874 13.3758 20.588C13.3758 13.6315 19.0072 8 25.9638 8C32.9203 8 38.5518 13.6315 38.5518 20.588C38.5518 23.8675 37.3261 26.9151 35.0735 29.2671V40H35.0404Z'
      fill='#292E34'
    />
    <path
      d='M33.4503 14.3934H28.9451V15.7184H31.1646L25.7981 21.118L20.3985 15.7184H22.618V14.3934H18.1459V18.8654H19.471V16.646L25.1356 22.3106V40H26.4606V22.3106L32.1252 16.646V18.8654H33.4503V14.3934Z'
      fill='#292E34'
    />
  </svg>
)

export default Philosophy
